import React, { useState } from "react";
import { Paragraph } from "@arctheme-components/elements/Paragraph/Paragraph";

interface MinicartNoteProps {
  settings: {
    cart_note_label?: string;
    cart_note_label_style?: string;
    cart_note_placeholder?: string;
  };
}

export const MinicartNote = ({ settings }: MinicartNoteProps) => {
  const [note, setNote] = useState("");
  const label = settings?.cart_note_label || "Note";
  const placeholder = settings?.cart_note_placeholder || "Add special instructions for your order";
  const labelStyle = settings?.cart_note_label_style || "text-sm font-medium text-gray-700";
  
  const handleNoteChange = (e) => {
    const value = e.target.value;
    setNote(value);
    
    // Update cart note using the ajax cart API
    const event = new CustomEvent('liquid-ajax-cart:request', {
      detail: {
        request: {
          url: '/cart/update.js',
          method: 'POST',
          body: {
            note: value
          }
        }
      }
    });
    
    document.dispatchEvent(event);
  };
  
  return (
    <div className="minicart-note mt-4 mb-4">
      <label htmlFor="cart-note" className="block mb-1">
        <Paragraph classes={labelStyle} text={label} />
      </label>
      <textarea
        id="cart-note"
        name="note"
        rows={2}
        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-primary"
        placeholder={placeholder}
        value={note}
        onChange={handleNoteChange}
      ></textarea>
    </div>
  );
};